import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Alert, Tab } from '@mui/material';
import React, { useState } from 'react';
import consoleSvg from '../assets/console.svg';
import ScheduledExerciseList from '../exercise-list/ExerciseList';
import Fallback from '../fallback/Fallback';
import { ExerciseState, ExerciseSummary } from '../types';
import { useDesktop } from '../useDesktop';
import ScheduledExercisesSkeleton from './ScheduledExercisesSkeleton';

export interface ScheduledExercisesProps {
  exercises?: ExerciseSummary[];
  exercisesError?: boolean;
  loadingExercises: boolean;
  onChange: (exerciseState: ExerciseState) => void;
  onAction?: (exercise?: ExerciseSummary) => void;
}

const ScheduledExercises = ({
  exercises,
  exercisesError,
  loadingExercises,
  onChange,
  onAction,
}: ScheduledExercisesProps) => {
  const [selectedTab, selectTab] = useState(ExerciseState.Active);
  const onTabChange = (event: React.SyntheticEvent, newValue: ExerciseState) => {
    onChange(newValue);
    selectTab(newValue);
  };
  const isDesktop = useDesktop();

  return loadingExercises ? (
    <ScheduledExercisesSkeleton />
  ) : exercisesError ? (
    <Fallback
      imgSrc={consoleSvg}
      message={
        <Alert severity="error">Something went wrong and we couldn&lsquo;t load your exercises. Please try again</Alert>
      }
    />
  ) : exercises ? (
    <TabContext value={selectedTab}>
      <TabList
        onChange={onTabChange}
        sx={{ borderBottom: 1, borderColor: 'divider' }}
        variant={isDesktop ? 'standard' : 'fullWidth'}
      >
        <Tab label="Active" value={ExerciseState.Active} />
        <Tab label="Completed" value={ExerciseState.Finished} />
      </TabList>

      <TabPanel value={selectedTab}>
        <ScheduledExerciseList exercises={exercises} exerciseState={selectedTab} onEndExercise={onAction} />
      </TabPanel>
    </TabContext>
  ) : null;
};
export default ScheduledExercises;
